import React from "react";
import { useParams } from "react-router-dom";

import { SideNavigationLink } from "../../../components/SideNavigation";
// components
import ComponentLoader from "../../../components/Spinner/ComponentLoader";

import ErrorPage from "../../../pages/Error";

// hooks
import { useCompanySettings } from "../../../api/hooks";
import { useRbacPrimaryRolePermissions } from "../../../api/hooks";

// pages
import AllForms from "./SubPages/AllForms";
import AllReviews from "./SubPages/AllReviews";
import Assignments from "./SubPages/Assignments";
import ReviewCycles from "./SubPages/ReviewCycles";
// constants
import { CompanyReviewsNavigationLinks } from "./constants";

const CompanyReviews = () => {
	const { page = "cycles" } = useParams<{ page: string }>();

	const { data: reviewReportPermissions, isLoading: loadingReportPermissions } =
		useRbacPrimaryRolePermissions("review_report");
	const { data: reviewPermissions, isLoading: loadingReviewPermissions } = useRbacPrimaryRolePermissions("review");
	const { data: settings } = useCompanySettings();
	const isReviewGraphsEnabled = settings?.functions?.reviews?.review_graphs;

	const navLinks: SideNavigationLink[] = [];

	if (loadingReportPermissions || loadingReviewPermissions) {
		return <ComponentLoader />;
	}

	const addNavLink = (key: string) => {
		const reportLink = CompanyReviewsNavigationLinks.find((link) => link.key === key);
		if (reportLink) {
			navLinks.push(reportLink);
		}
	};

	// add the nav links based on the permissions or throw error page if the user doesn't have the permission but is on the page
	if (reviewPermissions?.includes("review_cycle:viewCompanyReviewCycles")) {
		addNavLink("cycles");
	}
	if (reviewPermissions?.includes("reviews:viewCompanyAllReviews")) {
		addNavLink("all");
	}
	if (reviewReportPermissions?.includes("review_reports:viewCompanyAllForms")) {
		addNavLink("form-report");
	}
	if (reviewPermissions?.includes("reviews:viewCompanyAssignments")) {
		addNavLink("overview");
	}
	if (reviewPermissions?.includes("reviews:viewCompanyPerformanceGraphs") && isReviewGraphsEnabled) {
		addNavLink("graphs");
	}

	//is current page in available links
	if (!navLinks.find((link) => link.key === page)) {
		return <ErrorPage code={403} />;
	}

	return (
		<div>
			{page === "cycles" && <ReviewCycles navLinks={navLinks} />}
			{page === "all" && <AllReviews navLinks={navLinks} />}
			{page === "form-report" && <AllForms navLinks={navLinks} />}
			{page === "overview" && <Assignments navLinks={navLinks} />}
		</div>
	);
};

export default CompanyReviews;
